import React from 'react';
import useEventData from "../../../../custom_hooks/useEventData";
import { IMediaFolder } from "../../type/media-hub.types";
import { mapEventToFolderViewModel } from "../../action/media-hub.actions";
import MediaHubEventSectionView from "./media-folders.view";
import { Dayjs } from 'dayjs';
import Locale from "../../../../core/locale/locale";
import "../../../../styles/component/media-folder.scss";


const MediaFolders: React.FC<IMediaFolder> = (props) => {

    const formatDate = (date: Dayjs) => (date.format(Locale.dateFormat));

    const {data,isLoading} = useEventData({
        startDate: formatDate(props.date.startOf('year')),
        endDate: formatDate(props.date.endOf('year')),
        activeCategory: props.categorySelected
    });


    const mediaItems = mapEventToFolderViewModel(data);


    //filter the data according to the event name searched.
    const filteredItems = props.searchTerm
        ? mediaItems.filter((item) =>
            item.name.toLowerCase().includes(props.searchTerm?.toLowerCase() ?? ""))
        : mediaItems;


    return (
        <MediaHubEventSectionView
            isLoading={isLoading}
            date={props.date}
            data={filteredItems}
        />
    )
}

export default MediaFolders;
